import { usePerformanceByAccounts } from "@api/v1/hooks/performance/usePerformanceByAccounts";

export const usePreparePerformanceChart = (
  depotIds: number[],
  startDate: Date,
  endDate: Date
) => {
  const { data, ...queryStatus } = usePerformanceByAccounts({
    accountIds: depotIds,
    startDate,
    endDate,
    interval: "week",
  });

  if (depotIds.length === 0) {
    return {
      rawData: undefined,
      currentPortfolioValue: undefined,
      chartData: [],
      ...queryStatus,
    };
  }

  const results = data?.withoutCash;
  const chartData = results?.twrorResults
    ?.filter(({ date, portfolioValue }) => date && portfolioValue !== undefined)
    .map(({ date, portfolioValue }) => ({
      date: date!,
      value: portfolioValue!,
    }));

  const currentPortfolioValue =
    chartData && chartData[chartData?.length - 1]
      ? chartData[chartData?.length - 1].value
      : undefined;

  return { rawData: results, currentPortfolioValue, chartData, ...queryStatus };
};
